export default __webpack_public_path__ + "static/media/qr_code.c4d1b1d8.png";